export interface RealtimeConnectionDecision {
  stopped: boolean;
  browserReportsOnline: boolean;
  reconnectScheduled: boolean;
  socketState: "none" | "connecting" | "open" | "closing" | "closed";
}

/**
 * `navigator.onLine` is only a browser/OS hint. Edge can report `false` while
 * the current site and WebSocket are reachable, so it must never block a
 * connection attempt.
 */
export function shouldAttemptRealtimeConnection(
  input: RealtimeConnectionDecision,
): boolean {
  return (
    !input.stopped &&
    !input.reconnectScheduled &&
    input.socketState !== "connecting" &&
    input.socketState !== "open"
  );
}

export function realtimeReconnectDelay(attempt: number): number {
  const delays = [500, 1_000, 2_000, 5_000, 10_000] as const;
  return delays[Math.min(Math.max(0, attempt), delays.length - 1)] ?? 10_000;
}

